import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";
import { actionCreators } from "../redux/discountsSagas";

const DiscountLineChart = () => {
  const dispatch = useDispatch();
  const {
    trendData: { data_table: { rows = [], cols = [] } = {}, options = {} },
    selectedFilters: { table_view }
  } = useSelector((state) => state.discounts);

  if (!rows.length) return <NoData />;

  return (
    <GoogleChart
      enableEventListeners
      chartName="discounts_trend_chart"
      chartType={table_view ? "Table" : "LineChart"}
      width={table_view ? "100%" : "1350px"}
      height={400}
      isTableView={table_view}
      rows={rows}
      columns={cols}
      options={options}
      showCurrency={false}
      showAdditionTooltip={false}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default DiscountLineChart;
